import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';
import HeroBackdrop from './HeroBackdrop';
import { HeroTone, heroShell } from '../../content/heroThemes';

export const PAGE_HERO_HEIGHT_CLASS = 'h-[12rem] md:h-[15.5rem]';

interface PageHeroProps {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  icon?: LucideIcon;
  children?: React.ReactNode;
  tone?: HeroTone;
}

const PageHero: React.FC<PageHeroProps> = ({
  title,
  subtitle,
  eyebrow,
  icon: Icon,
  children,
  tone = 'home',
}) => {
  return (
    <section className={heroShell(tone)}>
      <HeroBackdrop tone={tone} />
      <div className={`relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 ${PAGE_HERO_HEIGHT_CLASS} flex items-center justify-center text-center`}>
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          {eyebrow && (
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 ring-1 ring-white/20 px-3 py-1 text-xs font-medium text-primary-100 backdrop-blur-sm">
              {Icon && <Icon className="h-3.5 w-3.5" />}
              {eyebrow}
            </span>
          )}
          <h1 className={`${eyebrow ? 'mt-4' : ''} text-2xl md:text-3xl lg:text-4xl font-bold leading-tight`}>
            {title}
          </h1>
          {subtitle && (
            <p className="mt-3 text-base md:text-lg text-primary-100/90 max-w-2xl mx-auto">
              {subtitle}
            </p>
          )}
          {children && <div className="mt-6 flex flex-wrap justify-center gap-4">{children}</div>}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
